import React from "react";

import { Body2, Button, LargeTitle, Title2 } from "@fluentui/react-components";
import { useHomeStyles } from "./home.styles";

import Details from "./components/details";
import { CONFIG } from "../../config";
import { Environment } from "../../service/globalTypes";
import LOGO_URL from "../../../assets/logo.svg";

const LOGO_ALT = "Cicada";
const LOGO_WIDTH = 200;

interface HomeProps {
  onContinue: () => void;
}

const Home = ({ onContinue }: HomeProps) => {
  const styles = useHomeStyles();

  return (
    <div className={styles.root}>
      <div className={styles.logoBg}>
        <img width={LOGO_WIDTH} src={LOGO_URL} alt={LOGO_ALT} />
      </div>

      <div className={styles.dataContainer}>
        <LargeTitle className={styles.mainTitle}>Welcome</LargeTitle>

        <Title2>Getting Started</Title2>

        <div className={styles.paragraphsContainer}>
          <Body2>
            Supercharge Excel with the Cicada Excel Add-in for seamless trading integration and real-time updates.
          </Body2>
        </div>

        <Details />
      </div>

      <Button onClick={onContinue} className={styles.startButton} appearance="primary">
        Start
      </Button>

      <p
        className={
          [Environment.DEMO, Environment.PRODUCTION].includes(CONFIG.BUILD_ENVIRONMENT)
            ? styles.appProdVersion
            : styles.appSandboxVersion
        }
      >
        Cicada Add-In {CONFIG.VERSION}
      </p>
    </div>
  );
};

export default Home;
